import { render, staticRenderFns } from "./contract-xianshang.vue?vue&type=template&id=6dada072&scoped=true"
import script from "./contract-xianshang.vue?vue&type=script&lang=js"
export * from "./contract-xianshang.vue?vue&type=script&lang=js"
import style0 from "./contract-xianshang.vue?vue&type=style&index=0&id=6dada072&prod&lang=css"
import style1 from "./contract-xianshang.vue?vue&type=style&index=1&id=6dada072&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dada072",
  null
  
)

export default component.exports